module.exports = __webpack_public_path__ + "media/images/iconPlus__inFrontOfAccent-09ee224c01feebdfdd5dd5163084bcbf.png";